import React from 'react';
import '../../../assets/css/pages/guidelines/sections/guidelineCardStyle.scss';

const GuidelineCard = ({guideline, handleDelete, handleUpdate, handleChange, handlePdfFileChange, handleIconChange}) => {
    const {id, titleEn, iconTag, iconBase64, backgroundColor, pdfEnTag} = guideline;
    return (
        <div className="guideline-custom-card">
            <div className="guideline-custom-card-header" style={{background: backgroundColor}}>
                <div className="image-uploader">
                    <label className="icon-update-btn" htmlFor={`uploader${id}`}>
                        <i className="fa fa-pencil"></i>
                    </label>
                    <input onChange={(e) => handleIconChange(e, id)} id={`uploader${id}`} className="d-none" type="file" accept="image/*"/>
                </div>
                <img
                    src={`data:image/jpg;base64,${iconBase64}`}
                    alt={iconTag}
                />
            </div>
            <div className="guideline-custom-card-body">
                <div className='form__div-container w-100'>
                    <div className="form__div">
                        <input
                            required
                            type='text'
                            name="titleEn"
                            className="form__input"
                            maxLength={15}
                            placeholder=" "
                            onChange={(e) => handleChange(e, id)}
                            value={titleEn}
                        />
                        <label htmlFor="" className="form__label">Title</label>
                    </div>
                </div>
                <div className='form__div-container w-100'>
                    <div className="form__div">
                        <input
                            required
                            type='color'
                            name="backgroundColor"
                            className="form__input clickable"
                            placeholder=" "
                            onChange={(e) => handleChange(e, id)}
                            value={backgroundColor}
                        />
                        <label htmlFor="" className="form__label">Backgroud Color</label>
                    </div>
                </div>
                <div className='form__div-container w-100 mb-3'>
                    <div className='d-flex align-items-center'>
                        <label htmlFor={`pdfUploader${id}`}>
                            <i className='fa fa-cloud-upload fa-2x clickable' style={{color: "#354e80"}}></i>
                        </label>
                        <input onChange={(e) => handlePdfFileChange(e, id)} id={`pdfUploader${id}`} type="file" className='d-none'/>
                        <p title={pdfEnTag} className='mb-2 ml-2 text-nowrap overflow-hidden'
                           style={{textOverflow: "ellipsis"}}>{pdfEnTag}</p>
                    </div>
                </div>
                <div className='text-center'>
                    <button onClick={() => handleDelete(id)} type="button" className="delete-btn">Delete</button>
                    <button onClick={() => handleUpdate(id)} type="submit" className="save-btn ml-2">Save</button>
                </div>
            </div>
        </div>
    );
};

export default GuidelineCard;
